  <main>
    <section class="layout-pt-lg layout-pb-lg bg-blue-2">
      <div class="container">
        <div class="row justify-center">
          <div class="col-xl-6 col-lg-7 col-md-9">
            <div class="px-50 py-50 sm:px-20 sm:py-20 bg-white shadow-4 rounded-4">
              <form [formGroup]="loginForm" (ngSubmit)="login()">
              <div class="row y-gap-20">
                <div class="col-12">
                  <h1 class="text-22 fw-500">Giriş Yap</h1>
                    <p class="mt-10">Henüz bir hesabın yok mu? <a [routerLink]="['/register']" class="text-blue-1">Ücretsiz kaydol</a></p>
                </div>

                  <!-- Hata Mesajları -->
                  <div class="col-12" *ngIf="errorMessage">
                    <div class="soft-alert">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                      <span>{{ errorMessage }}</span>
                    </div>
                  </div>

                  <!-- E-Mail -->
                  <div class="col-12">
                    <div class="form-input" [class.error]="email?.invalid && email?.touched">
                      <input 
                        type="email" 
                        formControlName="email"
                        [class.error]="email?.invalid && email?.touched">
                    <label class="lh-1 text-14 text-light-1">E-Mail</label>
                  </div>
                    <div *ngIf="email?.invalid && email?.touched" class="text-12 text-red-1 mt-5">
                      <span *ngIf="email?.errors?.['required']">E-posta zorunludur.</span>
                      <span *ngIf="email?.errors?.['email']">Geçerli bir e-posta adresi girin.</span>
                    </div>
                </div>

                  <!-- Şifre -->
                <div class="col-12">
                    <div class="form-input" [class.error]="password?.invalid && password?.touched">
                      <input 
                        type="password" 
                        formControlName="password"
                        [class.error]="password?.invalid && password?.touched">
                    <label class="lh-1 text-14 text-light-1">Şifre</label>
                  </div>
                    <div *ngIf="password?.invalid && password?.touched" class="text-12 text-red-1 mt-5">
                      Şifre zorunludur.
                    </div>
                </div>

                <div class="col-12">
                  <button type="button" (click)="openForgotPasswordModal()" class="forgot-password-link text-14 fw-500 text-blue-1 underline">Şifreni mi unuttun?</button>
                </div>

                <div class="col-12">
                  <app-loading *ngIf="isLoading" [size]="'small'" [message]="'Giriş yapılıyor...'"></app-loading>
                  <button
                    *ngIf="!isLoading"
                    type="submit"
                    class="button py-20 -dark-1 bg-blue-1 text-white col-12"
                    style="width: 100%; display: flex; align-items: center; justify-content: center;">
                    Giriş Yap <div class="icon-arrow-top-right ml-15"></div>
                  </button>
                </div>
              </div>
              </form>

              <div class="row y-gap-20 pt-30">
                <div class="col-12">
                  <div class="text-center"> veya giriş yapmak için</div>

                  <!-- Google Sign-In Button Container -->
                  <div id="googleSignInButton" class="mt-15" style="display: flex; justify-content: center; width: 100%;"></div>
                </div>

                <div class="col-12">
                  <div class="text-center px-30">Hesabınızı oluşturmakla Pusula Tatil Kullanım Koşulları ve Gizlilik Politikasını kabul ediyorsunuz.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Şifremi Unuttum Modal -->
    <div class="fp-overlay" *ngIf="showForgotPasswordModal" (click)="closeForgotPasswordModal()">
      <div class="fp-modal" (click)="$event.stopPropagation()">
        
        <!-- Kapatma Butonu -->
        <button type="button" class="fp-close-btn" (click)="closeForgotPasswordModal()">
          ✕
        </button>

        <!-- Step Indicator - 3 Adım -->
        <div class="fp-steps">
          <div class="fp-step" [class.active]="forgotPasswordStep === 'email'" [class.completed]="forgotPasswordStep === 'code' || forgotPasswordStep === 'password'">
            <div class="fp-step-number">{{ (forgotPasswordStep === 'code' || forgotPasswordStep === 'password') ? '✓' : '1' }}</div>
            <span>E-posta</span>
          </div>
          <div class="fp-step-line" [class.active]="forgotPasswordStep === 'code' || forgotPasswordStep === 'password'"></div>
          <div class="fp-step" [class.active]="forgotPasswordStep === 'code'" [class.completed]="forgotPasswordStep === 'password'">
            <div class="fp-step-number">{{ forgotPasswordStep === 'password' ? '✓' : '2' }}</div>
            <span>Kod</span>
          </div>
          <div class="fp-step-line" [class.active]="forgotPasswordStep === 'password'"></div>
          <div class="fp-step" [class.active]="forgotPasswordStep === 'password'">
            <div class="fp-step-number">3</div>
            <span>Şifre</span>
          </div>
        </div>

        <!-- Modal Header -->
        <div class="fp-header">
          <!-- Email Step Icon -->
          <div class="fp-icon" *ngIf="forgotPasswordStep === 'email'">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              <circle cx="12" cy="16" r="1"></circle>
            </svg>
          </div>
          <!-- Code Step Icon -->
          <div class="fp-icon success" *ngIf="forgotPasswordStep === 'code'">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <!-- Password Step Icon -->
          <div class="fp-icon" *ngIf="forgotPasswordStep === 'password'" style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); color: #d97706;">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <h2>
            <span *ngIf="forgotPasswordStep === 'email'">Şifreni mi unuttun?</span>
            <span *ngIf="forgotPasswordStep === 'code'">Doğrulama Kodu</span>
            <span *ngIf="forgotPasswordStep === 'password'">Yeni Şifre Belirle</span>
          </h2>
          <p *ngIf="forgotPasswordStep === 'email'">
            Endişelenme! E-posta adresini gir, sana şifre sıfırlama kodu gönderelim.
          </p>
          <p *ngIf="forgotPasswordStep === 'code'">
            <strong>{{ forgotPasswordEmail }}</strong> adresine gönderilen 6 haneli kodu gir.
          </p>
          <p *ngIf="forgotPasswordStep === 'password'">
            Yeni şifreni belirle ve hesabına erişimi koru.
          </p>
        </div>

        <!-- Başarı Mesajı -->
        <div *ngIf="forgotPasswordSuccess" class="fp-alert fp-alert-success">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>{{ forgotPasswordSuccess }}</span>
        </div>
        
        <!-- Hata Mesajı -->
        <div *ngIf="forgotPasswordError" class="fp-alert fp-alert-error">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
          <span>{{ forgotPasswordError }}</span>
        </div>

        <!-- Loading State -->
        <div *ngIf="forgotPasswordLoading" class="fp-loading">
          <div class="fp-spinner"></div>
          <span *ngIf="forgotPasswordStep === 'email'">Doğrulama kodu gönderiliyor...</span>
          <span *ngIf="forgotPasswordStep === 'password'">Şifre sıfırlanıyor...</span>
        </div>
        
        <!-- Adım 1: E-posta Girişi -->
        <div *ngIf="forgotPasswordStep === 'email' && !forgotPasswordLoading" class="fp-form-section">
          <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendForgotPasswordCode()">
            <div class="fp-input-group" [class.error]="forgotEmail?.invalid && forgotEmail?.touched">
              <label>E-posta Adresi</label>
              <div class="fp-input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <input 
                  type="email" 
                  formControlName="email"
                  placeholder="ornek@email.com">
              </div>
              <div *ngIf="forgotEmail?.invalid && forgotEmail?.touched" class="fp-error-text">
                <span *ngIf="forgotEmail?.errors?.['required']">E-posta adresi zorunludur</span>
                <span *ngIf="forgotEmail?.errors?.['email']">Geçerli bir e-posta adresi girin</span>
              </div>
            </div>
            
            <button type="submit" class="fp-btn fp-btn-primary" [disabled]="forgotPasswordForm.invalid">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
              Doğrulama Kodu Gönder
            </button>
          </form>
        </div>
        
        <!-- Adım 2: Doğrulama Kodu Girişi -->
        <div *ngIf="forgotPasswordStep === 'code' && !forgotPasswordLoading" class="fp-form-section">
          <form [formGroup]="codeVerifyForm" (ngSubmit)="verifyCodeAndProceed()">
            <div class="fp-input-group" [class.error]="verifyCode?.invalid && verifyCode?.touched">
              <label>6 Haneli Doğrulama Kodu</label>
              <div class="fp-input-wrapper fp-code-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                <input 
                  type="text" 
                  formControlName="code"
                  maxlength="6"
                  placeholder="000000"
                  class="fp-code-input">
              </div>
              <div *ngIf="verifyCode?.invalid && verifyCode?.touched" class="fp-error-text">
                <span *ngIf="verifyCode?.errors?.['required']">Doğrulama kodu zorunludur</span>
                <span *ngIf="verifyCode?.errors?.['pattern'] || verifyCode?.errors?.['minlength'] || verifyCode?.errors?.['maxlength']">6 haneli sayısal kod giriniz</span>
              </div>
            </div>
            
            <div class="fp-button-group">
              <button type="submit" class="fp-btn fp-btn-primary" [disabled]="codeVerifyForm.invalid">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
                Devam Et
              </button>
              <button type="button" class="fp-btn fp-btn-secondary" (click)="resendCode()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                </svg>
                Yeni Kod
              </button>
            </div>
          </form>
        </div>
        
        <!-- Adım 3: Yeni Şifre Belirleme -->
        <div *ngIf="forgotPasswordStep === 'password' && !forgotPasswordLoading" class="fp-form-section">
          <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
            
            <!-- Yeni Şifre -->
            <div class="fp-input-group" [class.error]="newPassword?.invalid && newPassword?.touched">
              <label>Yeni Şifre</label>
              <div class="fp-input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                <input 
                  type="password" 
                  formControlName="newPassword"
                  placeholder="••••••••">
              </div>
            </div>
            
            <!-- Şifre Gereksinimleri -->
            <div class="fp-password-rules">
              <div class="fp-rule" [class.valid]="newPassword?.value?.length >= 6" [class.invalid]="newPassword?.value && newPassword?.value?.length < 6">
                <span class="fp-rule-icon">{{ newPassword?.value?.length >= 6 ? '✓' : '○' }}</span>
                <span>En az 6 karakter</span>
              </div>
              <div class="fp-rule" [class.valid]="newPassword?.value && !newPassword?.errors?.['noUppercase']" [class.invalid]="newPassword?.value && newPassword?.errors?.['noUppercase']">
                <span class="fp-rule-icon">{{ newPassword?.value && !newPassword?.errors?.['noUppercase'] ? '✓' : '○' }}</span>
                <span>Büyük harf (A-Z)</span>
              </div>
              <div class="fp-rule" [class.valid]="newPassword?.value && !newPassword?.errors?.['noLowercase']" [class.invalid]="newPassword?.value && newPassword?.errors?.['noLowercase']">
                <span class="fp-rule-icon">{{ newPassword?.value && !newPassword?.errors?.['noLowercase'] ? '✓' : '○' }}</span>
                <span>Küçük harf (a-z)</span>
              </div>
              <div class="fp-rule" [class.valid]="newPassword?.value && !newPassword?.errors?.['noDigit']" [class.invalid]="newPassword?.value && newPassword?.errors?.['noDigit']">
                <span class="fp-rule-icon">{{ newPassword?.value && !newPassword?.errors?.['noDigit'] ? '✓' : '○' }}</span>
                <span>Rakam (0-9)</span>
              </div>
              <div class="fp-rule" [class.valid]="newPassword?.value && !newPassword?.errors?.['noSpecial']" [class.invalid]="newPassword?.value && newPassword?.errors?.['noSpecial']">
                <span class="fp-rule-icon">{{ newPassword?.value && !newPassword?.errors?.['noSpecial'] ? '✓' : '○' }}</span>
                <span>Özel karakter (!&#64;#$%)</span>
              </div>
            </div>
            
            <!-- Şifre Tekrar -->
            <div class="fp-input-group" [class.error]="(confirmPassword?.invalid && confirmPassword?.touched) || (resetPasswordForm.errors?.['passwordMismatch'] && confirmPassword?.touched)">
              <label>Şifre Tekrar</label>
              <div class="fp-input-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                <input 
                  type="password" 
                  formControlName="confirmPassword"
                  placeholder="••••••••">
              </div>
              <div *ngIf="confirmPassword?.touched" class="fp-error-text">
                <span *ngIf="confirmPassword?.errors?.['required']">Şifre tekrarı zorunludur</span>
                <span *ngIf="resetPasswordForm.errors?.['passwordMismatch'] && !confirmPassword?.errors?.['required']">Şifreler eşleşmiyor</span>
              </div>
            </div>
            
            <div class="fp-button-group">
              <button type="submit" class="fp-btn fp-btn-primary" [disabled]="resetPasswordForm.invalid">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                Şifreyi Sıfırla
              </button>
              <button type="button" class="fp-btn fp-btn-secondary" (click)="goBackToCode()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                Geri
              </button>
            </div>
          </form>
        </div>

        <!-- Footer -->
        <div class="fp-footer" *ngIf="!forgotPasswordLoading">
          <button type="button" class="fp-back-link" (click)="closeForgotPasswordModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            Giriş sayfasına dön
          </button>
        </div>
      </div>
    </div>

  </main>